/** @param {string} platform */
export const getLastUsedVersion = platform => storage.getItem(`${prefix}-${platform}`)

/**
 * @param {string} platform
 * @param {string} version
 */
export const setLastUsedVersion = (platform, version) => storage.setItem(`${prefix}-${platform}`, version)

const prefix = 'sdk-version'

/** @type {Storage}  */
const storage =
	typeof sessionStorage !== 'undefined'
		? sessionStorage
		: {
				getItem: () => null,
				setItem: () => undefined,
		  }
